<template>
    <div class="FosterFamilyAssignmentEditor">
        <div v-if="CheckPermission(ViewPermissionRequirement)">
            <b-container>
                <b-row style="overflow-x:auto;">
                    <b-col cols="11">
                        <vuetable :fields="Fields"
                                  :data="FieldData"
                                  pagination-path=""
                                  :api-mode="false"
                                  class="vue-datatable"
                                  row-class="bold-first-row">
                        </vuetable>
                    </b-col>
                    <b-col cols="1">
                        <div v-if="EditMode && CheckPermission(EditPermission)" class="vert-icons">
                            <b-row v-if="TableState == 'NoRecords'">
                                <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddRecord()" class="pointer olive-green-text" />
                            </b-row>
                            <b-row v-if="TableState == 'OneOpen'">
                                <font-awesome-icon :icon="['fas', 'exchange-alt']" v-on:click="ShowTransferRecord()" class="pointer olive-green-text" />
                            </b-row>
                            <b-row v-if="TableState == 'OneOpen'">
                                <font-awesome-icon :icon="['fas', 'trash-alt']" v-on:click="ShowDeleteRecord()" class="pointer red" />
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
            </b-container>

            <!--ADD NEW RECORD MODAL-->
            <b-modal ref="add-modal" :title="AddRecordModalTitle" hide-footer>
                <b-container>
                    <b-form @submit="AddRecord">
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>{{ SelectLabel }}</label>
                                    <select class="form-control" v-model="NewRecordValue" required>
                                        <option v-for="option in NewRecordOptions" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                        <option value="NonOliveCrestFamily">---NON OLIVE CREST FAMILY---</option>
                                    </select>
                                </div>
                                <div v-if="AddRecordDate" class="form-group">
                                    <label>Effective Date:</label>
                                    <flat-pickr v-model="AddRecordDate" class="form-control" ref="showfocus" required :config="DateConfig"></flat-pickr>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-if="NewRecordValue == 'NonOliveCrestFamily'">
                            <b-col>
                                <p>
                                    <span class="red">NOTE: </span>
                                    You have selected a Non Olive Crest Family.  This should only be used when a child is placed with a Family that is not an Olive Crest family (for example, BRS In Home).  Do not, under ANY circumstances, use this feature if the child is placed with an Olive Crest family.
                                </p>
                                <div class="form-group">
                                    <label>Non Olive Crest Family Name (Last Name, First Names)</label>
                                    <input v-model="NonOliveCrestFamily.Name" class="form-control" required />
                                </div>
                                <div class="form-group">
                                    <label>Physical Street Address Line 1:</label>
                                    <input v-model="NonOliveCrestFamily.AddressLine1" class="form-control" required />
                                </div>
                                <div class="form-group">
                                    <label>Physical Street Address Line 2 (optional):</label>
                                    <input v-model="NonOliveCrestFamily.AddressLine2" class="form-control" />
                                </div>
                                <div class="form-group">
                                    <label>City:</label>
                                    <input v-model="NonOliveCrestFamily.City" class="form-control" required />
                                </div>
                                <div class="form-group">
                                    <label>State:</label>
                                    <select v-model="NonOliveCrestFamily.StateAbbreviation" class="form-control" required>
                                        <option v-for="option in StateOptions" :value="option.value">{{option.text}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>County:</label>
                                    <select v-model="NonOliveCrestFamily.County" class="form-control">
                                        <option value="">-- Select County --</option>
                                        <option v-for="option in CountyOptions" :value="option.value">{{option.text}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Zip Code:</label>
                                    <input v-model="NonOliveCrestFamily.ZipCode" class="form-control" required />
                                </div>
                                <div v-if="IsCaregiverSupport" class="form-group">
                                    <label>Family Email:</label>
                                    <input v-model="NonOliveCrestFamily.SFEmail" class="form-control" />
                                </div>
                                <div v-if="IsCaregiverSupport" class="form-group">
                                    <label>Family Phone:</label>
                                    <input v-model="NonOliveCrestFamily.SFPhoneNumber" class="form-control" />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelAddRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>

            <!--TRANSFER RECORD MODAL-->
            <b-modal ref="transfer-modal" :title="TransferRecordModalTitle" hide-footer>
                <b-container>
                    <b-form @submit="TransferRecord">
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>{{ SelectLabel }}</label>
                                    <select class="form-control" v-model="NewRecordValue" required>
                                        <option v-for="option in NewRecordOptions" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                        <option value="NonOliveCrestFamily">---NON OLIVE CREST FAMILY---</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Effective Date:</label>
                                    <flat-pickr v-model="TransferEffectiveDate" class="form-control" ref="showfocus" required :config="DateConfig"></flat-pickr>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-if="NewRecordValue == 'NonOliveCrestFamily'">
                            <b-col>
                                <p>
                                    <span class="red">NOTE: </span>
                                    You have selected a Non Olive Crest Family.  This should only be used when a child is placed with a Family that is not an Olive Crest family (for example, BRS In Home).  Do not, under ANY circumstances, use this feature if the child is placed with an Olive Crest family.
                                </p>
                                <div class="form-group">
                                    <label>Non Olive Crest Family Name (Last Name, First Names)</label>
                                    <input v-model="NonOliveCrestFamily.Name" class="form-control" required />
                                </div>
                                <div class="form-group">
                                    <label>Physical Street Address Line 1:</label>
                                    <input v-model="NonOliveCrestFamily.AddressLine1" class="form-control" required />
                                </div>
                                <div class="form-group">
                                    <label>Physical Street Address Line 2 (optional):</label>
                                    <input v-model="NonOliveCrestFamily.AddressLine2" class="form-control" />
                                </div>
                                <div class="form-group">
                                    <label>City:</label>
                                    <input v-model="NonOliveCrestFamily.City" class="form-control" required />
                                </div>
                                <div class="form-group">
                                    <label>State:</label>
                                    <select v-model="NonOliveCrestFamily.StateAbbreviation" class="form-control" required>
                                        <option v-for="option in StateOptions" :value="option.value">{{option.text}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>County:</label>
                                    <select v-model="NonOliveCrestFamily.County" class="form-control">
                                        <option value="">-- Select County --</option>
                                        <option v-for="option in CountyOptions" :value="option.value">{{option.text}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Zip Code:</label>
                                    <input v-model="NonOliveCrestFamily.ZipCode" class="form-control" required />
                                </div>
                                <div v-if="IsCaregiverSupport" class="form-group">
                                    <label>Family Email:</label>
                                    <input v-model="NonOliveCrestFamily.SFEmail" class="form-control" />
                                </div>
                                <div v-if="IsCaregiverSupport" class="form-group">
                                    <label>Family Phone:</label>
                                    <input v-model="NonOliveCrestFamily.SFPhoneNumber" class="form-control" />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelTransferRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="success" type="submit">
                                    SAVE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>

            <!--DELETE CURRENT RECORD MODAL-->
            <b-modal ref="delete-modal" :title="DeleteRecordModalTitle" hide-footer>
                <b-container>
                    <b-form @submit="DeleteRecord">
                        <b-row>
                            <b-col>
                                <p>{{ DeleteRecordModalText }}</p>
                            </b-col>
                        </b-row>
                        <b-row class="modal-btn-row">
                            <div class="modal-btn-row-div">
                                <b-button size="md" variant="secondary" @click="CancelDeleteRecord()">
                                    CANCEL
                                </b-button>
                                <b-button size="md" variant="danger" type="submit">
                                    DELETE
                                </b-button>
                            </div>
                        </b-row>
                    </b-form>
                </b-container>
            </b-modal>
        </div>
        <div v-else>
            PRIVATE
        </div>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faExchangeAlt);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);

    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';


    export default {
        props: [
            
            "Fields",
            "FieldData",
            "SelectLabel",
            "OptionsType",//api,data
            "OptionsMethod",
            "OptionsMethodRecordId",
            "OptionsMethodRecordName",
            "AddRecordMethod",
            "AddRecordRecordPropertyName",
            "AddRecordAdditionalPayload",
            "AddRecordModalTitle",
            "AddRecordDate",

            "TransferRecordMethod",
            "TransferRecordRecordPropertyName",
            "TransferRecordEffectiveDatePropertyName",
            "TransferRecordAdditionalPayload",
            "TransferRecordModalTitle",

            "DeleteRecordMethod",
            "DeleteRecordRecordPropertyName",
            "DeleteRecordAdditionalPayload",
            "DeleteRecordModalTitle",
            "DeleteRecordModalText",

            "OldValue",
            "OldValueText",
            "PropertyName",
            "RecordId",
            "EditMode",
            "DataLabel",
            "UpdateMethod",
            "Required",
            "Options",
            "EditPermission",
            "ViewPermissionRequirement",

            "ChartId",
            "IsCaregiverSupport"
        ],
        data: function () {
            return {
                NewRecordValue: "",
                NewRecordOptions: {},
                TransferEffectiveDate: "",
                NonOliveCrestFamily: {},
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                }
            };
        },
        methods: {
            //ADD RECORD
            ShowAddRecord() {
                this.NewRecordValue = "";
                this.NonOliveCrestFamily = {};
                this.$MasterAPI.ExecuteRequest("GET", this.OptionsMethod, { [this.OptionsMethodRecordName === undefined ? "Id": this.OptionsMethodRecordName]: this.OptionsMethodRecordId }, this.ShowAddRecordSuccess, () => { }, false);
                
            },
            ShowAddRecordSuccess(response) {
                 this.$set(this, "NewRecordOptions", response.data.data);
                 this.$refs['add-modal'].show();
            },
            AddRecord(e) {
                e.preventDefault();
                var vm = this;

                if (this.NewRecordValue != "NonOliveCrestFamily") {
                    let initialPayload = { Id: this.RecordId, [this.AddRecordRecordPropertyName]: this.NewRecordValue, StartDate: this.AddRecordDate != null ? this.AddRecordDate : null };
                    let finalPayload = { ...initialPayload, ...this.AddRecordAdditionalPayload };
                    this.$MasterAPI.ExecuteRequest("POST", this.AddRecordMethod, finalPayload, this.AddRecordSuccess, () => { }, true);
                } else {
                    this.$MasterAPI.ExecuteRequest(
                        "POST",
                        "Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/AssignToNonOliveCrestFamily",
                        {
                            ClientSubProgramMembershipID: this.OptionsMethodRecordId,
                            Name: this.NonOliveCrestFamily.Name,
                            AddressLine1: this.NonOliveCrestFamily.AddressLine1,
                            AddressLine2: this.NonOliveCrestFamily.AddressLine2,
                            City: this.NonOliveCrestFamily.City,
                            StateAbbreviation: this.NonOliveCrestFamily.StateAbbreviation,
                            County: this.NonOliveCrestFamily.County,
                            ZipCode: this.NonOliveCrestFamily.ZipCode,
                            SFEmail: this.NonOliveCrestFamily.SFEmail,
                            SFPhoneNumber: this.NonOliveCrestFamily.SFPhoneNumber
                        },
                        this.AddRecordSuccess,
                        () => { },
                        true);
                }
                
            },
            AddRecordSuccess(response) {
                this.$refs['add-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            CancelAddRecord() {
                this.$refs['add-modal'].hide();
            },
            //TRANSFER RECORD
            ShowTransferRecord() {
                this.NewRecordValue = "";
                this.NonOliveCrestFamily = {};
                this.TransferEffectiveDate = "";
                this.$MasterAPI.ExecuteRequest("GET", this.OptionsMethod, { [this.OptionsMethodRecordName === undefined ? "Id": this.OptionsMethodRecordName]: this.OptionsMethodRecordId }, this.ShowTransferRecordSuccess, () => { }, false);
            },
            ShowTransferRecordSuccess(response) {
                this.$set(this, "NewRecordOptions", response.data.data);
                this.$refs['transfer-modal'].show();
            },
            TransferRecord(e) {
                e.preventDefault();
                var vm = this;
                if (this.NewRecordValue != "NonOliveCrestFamily") {
                    let initialPayload = { Id: this.RecordId, [this.TransferRecordEffectiveDatePropertyName]: this.TransferEffectiveDate, [this.TransferRecordRecordPropertyName]: this.NewRecordValue };
                    let finalPayload = { ...initialPayload, ...this.TransferRecordAdditionalPayload };
                    this.$MasterAPI.ExecuteRequest("POST", this.TransferRecordMethod, finalPayload, this.TransferRecordSuccess, () => { }, true);
                } else {
                    this.$MasterAPI.ExecuteRequest(
                        "POST",
                        "Foster/Membership_FosterResourceFamily_ClientSubProgramMembership/AssignToNonOliveCrestFamily",
                        {
                            ClientSubProgramMembershipID: this.OptionsMethodRecordId,
                            TransferEffectiveDate: this.TransferEffectiveDate,
                            Name: this.NonOliveCrestFamily.Name,
                            AddressLine1: this.NonOliveCrestFamily.AddressLine1,
                            AddressLine2: this.NonOliveCrestFamily.AddressLine2,
                            City: this.NonOliveCrestFamily.City,
                            StateAbbreviation: this.NonOliveCrestFamily.StateAbbreviation,
                            County: this.NonOliveCrestFamily.County,
                            ZipCode: this.NonOliveCrestFamily.ZipCode,
                            SFEmail: this.NonOliveCrestFamily.SFEmail,
                            SFPhoneNumber: this.NonOliveCrestFamily.SFPhoneNumber
                        },
                        this.TransferRecordSuccess,
                        () => { },
                        true);
                }
                
            },
            TransferRecordSuccess(response) {
                this.$refs['transfer-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            CancelTransferRecord() {
                this.$refs['transfer-modal'].hide();
            },
            //DELETE RECORD
            ShowDeleteRecord() {
                this.$refs['delete-modal'].show();
            },
            DeleteRecord(e) {
                e.preventDefault();
                var vm = this;
                let initialPayload = { Id: this.RecordId };
                let finalPayload = { ...initialPayload, ...this.DeleteRecordAdditionalPayload };
                this.$MasterAPI.ExecuteRequest("POST", this.DeleteRecordMethod, finalPayload, this.DeleteRecordSuccess, () => { }, true);
            },
            DeleteRecordSuccess(response) {
                this.$refs['delete-modal'].hide();
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            CancelDeleteRecord() {
                this.$refs['delete-modal'].hide();
            },

            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate (value, fmt = 'D MMM YYYY', defaultValue='') {
              return (value == null)
                ? defaultValue
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            Vuetable,
            flatPickr
        },
        computed: {
            ModalTitle: function () {
                return "Editing " + this.DataLabel;
            },
            TableState: function () {
                if (this.FieldData.length == 0) {
                    return "NoRecords";
                } else if (this.FieldData.filter(datalist => datalist.EndDate == null).length == 0) {
                    return "AllClosed";
                } else {
                    return "OneOpen";
                }
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top:10px;
    }
    /deep/ tbody tr:first-child {
        font-weight: bold;
    }
    table {
        table-layout:auto;
    }
    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>